import { SchedulingEventType } from '@principle-theorem/principle-core/interfaces';
import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface ISchedulingEventReasonDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  name: string;
  description: string;
  eventTypes: SchedulingEventType[];
  hrsBeforeAppointment?: number;
  moveToSameDayDefault: boolean;
  fillGapDefault: boolean;
  metadataKey: string;
  isSystemReason: boolean;
  metadataDisplayRef: ISerialisedDocumentReference;
}
